import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Link } from 'react-router-dom';
import { Container, Navbar, Nav, NavDropdown } from 'react-bootstrap';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import Clients from './components/Clients';
import Locations from './components/Locations';
import Devices from './components/Devices';
import Settings from './components/Settings';
import api from './api';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const savedUser = localStorage.getItem('user');
    
    if (token && savedUser) {
      try {
        setUser(JSON.parse(savedUser));
        api.get('/api/auth/verify')
          .then((response) => {
            setIsAuthenticated(true);
            setUser(response.data.user);
            localStorage.setItem('user', JSON.stringify(response.data.user));
          })
          .catch(() => {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            setIsAuthenticated(false);
            setUser(null);
          })
          .finally(() => setLoading(false));
      } catch (e) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
  }, []);

  const handleLogin = (token, userData) => {
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(userData));
    setUser(userData);
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
    setIsAuthenticated(false);
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Φόρτωση...</span>
        </div>
      </div>
    );
  }

  return (
    <Router>
      {isAuthenticated && user && (
        <Navbar bg="dark" variant="dark" expand="lg" className="mb-4">
          <Container fluid>
            <Navbar.Brand href="/dashboard">
              <i className="bi bi-thermometer-half me-2"></i>
              Temperature Monitor
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="me-auto">
                <Nav.Link as={Link} to="/dashboard">
                  <i className="bi bi-speedometer2 me-1"></i>
                  Dashboard
                </Nav.Link>
                
                {user.role === 'super_admin' && (
                  <Nav.Link as={Link} to="/clients">
                    <i className="bi bi-building me-1"></i>
                    Clients
                  </Nav.Link>
                )}
                
                <Nav.Link as={Link} to="/locations">
                  <i className="bi bi-geo-alt me-1"></i>
                  Τοποθεσίες
                </Nav.Link>
                
                <Nav.Link as={Link} to="/devices">
                  <i className="bi bi-thermometer me-1"></i>
                  Συσκευές
                </Nav.Link>

                <Nav.Link as={Link} to="/settings">
                  <i className="bi bi-gear me-1"></i>
                  Ρυθμίσεις
                </Nav.Link>
              </Nav>
              
              <Nav>
                <NavDropdown 
                  title={
                    <>
                      <i className="bi bi-person-circle me-1"></i>
                      {user.username}
                      {user.role === 'super_admin' && (
                        <span className="badge bg-danger ms-2">Admin</span>
                      )}
                    </>
                  } 
                  id="user-dropdown"
                  align="end"
                >
                  <NavDropdown.Item disabled>
                    <small className="text-muted">
                      {user.clientName || 'Super Administrator'}
                    </small>
                  </NavDropdown.Item>
                  <NavDropdown.Divider />
                  <NavDropdown.Item onClick={handleLogout}>
                    <i className="bi bi-box-arrow-right me-1"></i>
                    Αποσύνδεση
                  </NavDropdown.Item>
                </NavDropdown>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      )}

      <Routes>
        <Route 
          path="/login" 
          element={
            isAuthenticated ? <Navigate to="/dashboard" /> : <Login onLogin={handleLogin} />
          } 
        />
        <Route 
          path="/dashboard" 
          element={
            isAuthenticated ? <Dashboard user={user} /> : <Navigate to="/login" />
          } 
        />
        <Route 
          path="/clients" 
          element={
            isAuthenticated && user?.role === 'super_admin' ? (
              <Clients user={user} />
            ) : (
              <Navigate to="/dashboard" />
            )
          } 
        />
        <Route 
          path="/locations" 
          element={
            isAuthenticated ? <Locations user={user} /> : <Navigate to="/login" />
          } 
        />
        <Route 
          path="/devices" 
          element={
            isAuthenticated ? <Devices user={user} /> : <Navigate to="/login" />
          } 
        />
        <Route 
          path="/settings" 
          element={
            isAuthenticated ? <Settings /> : <Navigate to="/login" />
          } 
        />
        <Route path="/" element={<Navigate to="/dashboard" />} />
      </Routes>
    </Router>
  );
}

export default App;